import axios, { AxiosRequestConfig } from 'axios'
import { isNil } from 'lodash'
import {
  ReadSfWalletsRequestDto,
  ReadSfWalletsResponseDto,
  CreateSfWalletRequestDto,
  CreateSfWalletResponseDto,
  UpdateSfWalletRequestDto,
  UpdateSfWalletResponseDto,
  ReadUserSfWalletsRequestDto,
  ReadUserSfWalletsResponseDto,
  AssignSfWalletToUserRequestDto,
  AssignSfWalletToUserResponseDto,
  UnassignSfWalletFromUserRequestDto,
  UnassignSfWalletFromUserResponseDto,
} from '@sparling/financial-common'

export const fetchSfWallets = async (
  { token, ...params }: ReadSfWalletsRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<ReadSfWalletsResponseDto> => {
  const response = await axios.get<ReadSfWalletsResponseDto>(`${process.env.REACT_APP_SERVER_URL}/crm/sf-wallets`, {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })
  return response.data
}

export const createSfWallets = async (
  { token, ...params }: CreateSfWalletRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<CreateSfWalletResponseDto> => {
  const response = await axios.post<CreateSfWalletResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/sf-wallets`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateSfWallets = async (
  { token, id, ...params }: UpdateSfWalletRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateSfWalletResponseDto> => {
  const response = await axios.put<UpdateSfWalletResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/sf-wallets/${id}`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const getAssignedWalletsByUser = async (
  { token, idSf, page, count }: ReadUserSfWalletsRequestDto & { token: string },
  options: RequestInit = {},
): Promise<ReadUserSfWalletsResponseDto> => {
  const response = await window.fetch(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/assigned-wallets/${idSf}?page=${page}&count=${count || 10}`,
    {
      ...options,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...options.headers,
      },
    },
  )
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const getAssignedWalletIdsByUser = async (
  { token, idSf }: { token: string; idSf: string },
  options: RequestInit = {},
): Promise<number[]> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/assigned-wallet-ids/${idSf}`, {
    ...options,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const assignSfWalletToUser = async (
  { token, ...params }: AssignSfWalletToUserRequestDto & { token: string },
  options: RequestInit = {},
): Promise<AssignSfWalletToUserResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/assign-wallet`, {
    ...options,
    body: JSON.stringify(params),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}

export const unassignSfWalletFromUser = async (
  { token, ...params }: UnassignSfWalletFromUserRequestDto & { token: string },
  options: RequestInit = {},
): Promise<UnassignSfWalletFromUserResponseDto> => {
  const response = await window.fetch(`${process.env.REACT_APP_SERVER_URL}/crm/user/unassign-wallet`, {
    ...options,
    body: JSON.stringify(params),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  })
  // eslint-disable-next-line no-return-await
  return await response.json()
}
